import cmsAU from './cms-au.json';
import cmsUS from './cms-us.json';
import cmsUK from './cms-uk.json';
import cmsCA from './cms-ca.json';
import cmsNZ from './cms-nz.json';
import cmsIE from './cms-ie.json';

export default {
    'au': cmsAU,
    'us': cmsUS,
    'uk': cmsUK,
    'ca': cmsCA,
    'nz': cmsNZ,
    'ie': cmsIE
};

